<template>
    <div v-if="view">
        <h3 class="custom-font-tea mt-0 mb-2">Teaching record (Extra & Part-time)</h3>
        <p class="custom-font-tea mt-0 mb-1">You are only required to upload the log record for courses under extra teaching payment or if you are a part-time instructor</p>
        <div class="row mb-2 mt-2">
            <div class="col-md-6">
                <button 
                    @click="ToFormTeaching"
                    type="button" 
                    class="mt-0 mr-2 btn btn-info font-ene"
                >
                    <i class="fa fa-pencil-square-o"></i> Create Teaching record
                </button>
            </div>
        </div>
        <hr>
        <b-form class="mt-3" inline>
            <label class="thai-font mr-2" for=""><i class="fa fa-search mr-2"></i></label>
            <b-input 
                v-model="filter" 
                style="width:25%"
                type="search" 
                size="sm"
                id="filterInput" 
                class="thai-font mb-2 mr-sm-2 mb-sm-0" placeholder="filter..."
            ></b-input>
        </b-form>
        <b-table
            class="mt-3"
            head-variant="dark"
            small show-empty bordered striped responsive="sm"
            :items="dataTeaching"
            :fields="fields"
            id="my-table-teaching" 
            :filter="filter"
            @filtered="onFiltered"
            style="font-size:0.8rem;font-weight:600"
        >
            <template v-slot:cell(c0)="sc0">{{ sc0.value }}</template>
            <template v-slot:cell(c1)="sc1">{{ sc1.value }}</template>
            <template v-slot:cell(c2)="sc2">{{ sc2.item.cs }}</template>
            <template v-slot:cell(c3)="sc3">
                <span class="" :class="{ 'text-success' : sc3.value === 'Approved' , 'text-danger' : sc3.value === 'Disapproved' }">
                    <span>{{ sc3.value === 'wait' ? 'Pending' : sc3.value }}</span>
                </span>
            </template>
            <template v-slot:cell(cx)="scx">
                <!-- {{ scx.value }} -->
                <b-link @click="getImage(scx.value,scx.item.c4,getFileExtension(scx.value.split('+')[0]))" size="sm" variant="info">
                    View
                </b-link>
            </template>
            <template v-slot:cell(c4)="sc4">
                <!-- {{ sc4.item.c4 }} -->
                <span v-if="sc4.item.c3 === 'wait'">
                    <b-button @click="ToFormEditTeaching(sc4.item)" size="sm" class="text-capitalize mb-2 mr-1" variant="info"><i class="fa fa-pencil" aria-hidden="true"></i></b-button>
                    <b-button @click="Del(sc4.value)" size="sm" class="text-capitalize mb-2" variant="danger"><i class="fa fa-trash" aria-hidden="true"></i></b-button>
                </span>
            </template>
        </b-table>
        <!-- <p style="font-size:0.8rem;font-weight:600" class="mt-0">
            Please contact : Tel. +66 (0) 2700 5000 Ext. 4205 , 4206 , 4208 or icit@mahidol.ac.th  
            If you could not find needed course.
        </p> -->
    </div>
</template>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap');
    .custom-font-tea{
        font-family: 'Nunito', sans-serif;
        font-weight: 100;
    }
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Rubik', sans-serif; }
</style>

<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        data() {
            return {
                view:false,
                dataTeaching: [],
                perPage: 25,
                currentPage: 1,
                filter: null,
                filterOn: [],
                fields: [
                    {
                        sortable: true, 
                        key: 'c0', 
                        label: 'Course',
                        thStyle: 
                        { 
                            width:'30%',
                        }
                    },
                    {
                        sortable: true, 
                        key: 'cT', 
                        label: 'Term',
                        thStyle: 
                        { 
                            width:'10%',
                        }
                    },
                    {
                        sortable: true, 
                        key: 'c1', 
                        label: 'Section',
                        class: 'text-center',
                        thStyle: 
                        { 
                            width:'10%',
                        }
                    },
                    {
                        sortable: true, 
                        key: 'c2', 
                        label: 'Teaching period',
                        class: 'text-center',
                        thStyle: 
                        { 
                            width:'15%',
                        }
                    },
                    {
                        sortable: true, 
                        key: 'c3', 
                        label: 'Status',
                        class: 'text-center',
                        thStyle: 
                        { 
                            width:'10%',
                        }
                    },
                    {
                        sortable: true, 
                        key: 'cx', 
                        label: 'File',
                        class: 'text-center',
                        thStyle: 
                        { 
                            width:'10%',
                        }
                    },
                    {
                        sortable: true, 
                        key: 'c4', 
                        label: 'Action',
                        class: 'text-center',
                        thStyle: 
                        { 
                            width:'20%',
                        }
                    },
                ],
            }
        },
        computed: {
            rows() {
                return this.dataTeaching.length
            },
            sortOptions() {
                return this.fields.filter(f => f.sortable).map(f => {
                    return { text: f.label, value: f.key }
                })
            },
            ...mapGetters({
                msg: 'getRules'
            }),
        },
        mounted(){
            this.checkMsgWhoAmi()
            this.LoadTeachingHistory()
        },
        methods: {
            checkMsgWhoAmi(){
                var count = 0
                var arr = ['faculty']
                // console.log(this.checkMsgDev('TeamDev:admin'))
                for (let index = 0; index < this.$store.state.permit.RulesUser.roles.length; index++) {
                    // console.log(this.$route.meta.permitC.includes(this.$store.state.permit.RulesUser.roles[index]))
                    if(arr.includes(this.$store.state.permit.RulesUser.roles[index]) || this.checkMsgDev('TeamDev:admin')){
                        count++
                    }
                }
                // console.log(count)
                if(count == 0){
                    this.$router.push("/").catch(err => {})
                }else{
                    this.view = true
                }
            },
            checkMsgDev(ValueChk){
                return this.msg.permissions.includes(ValueChk)
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            ToFormTeaching(){
                this.$router.push('/formteaching')
            },
            ToFormEditTeaching(objItem){
                // console.log(objItem)
                this.$router.push({
                    name:"Teaching record submission form edit",
                    params: { 
                        id: objItem.c4,
                        upload_file: objItem.cx,
                        course: objItem.c0,
                        section: objItem.c1,
                        week: objItem.c2,
                        term: objItem.cT,
                    }, 
                }).catch(err => {})
            },
            async LoadTeachingHistory(){
                this.dataTeaching = []
                try {
                    const res = await this.$http.get('/teaching/note/me/')
                    if(res.status === 200){
                        this.dataTeaching = res.data.map(item => {
                            return { 
                                'c0': item.course,
                                'c1': item.section,
                                'c2': item.around,
                                'cs': item.around_show.period,
                                'cx': item.upload_file,
                                // 'cx': `${item.upload_file}/#/${item.file_tmp}`,
                                'c3': item.status,
                                'c4': Number(item.id),
                                'cT' : item.term
                                // 'created_at':item.created_at,
                            }
                        })
                        // sort
                        this.dataTeaching.sort((a, b) =>{ return b.c4 - a.c4; });
                    }else{
                        throw { res }
                    }
                } catch (error) {}
            },
            async getImage(nameFile,id,typeFile){
                try {
                    var type_f = ''
                    if(typeFile === 'pdf'){
                        var type_f = 'application/pdf'
                    }else if(typeFile === 'zip'){
                        var type_f = 'application/zip'
                    }
                    else if(typeFile === 'rar'){
                        var type_f = 'rar'
                    }
                    else if(typeFile === '7zip'){
                        var type_f = '7zip'
                    }
                    else if(typeFile === 'csv'){
                        var type_f = 'csv'
                    }
                    else if(typeFile === 'xlsx'){
                        var type_f = 'application/vnd.ms-excel'
                    }
                    else{
                        var type_f = 'image/png'
                    }
                    const res = this.$http.get(`/teaching/note/${id}/getfile/`,{ 'responseType': 'blob' }).then((res) => {
                        let blob = new Blob([res.data], {
                            type: type_f
                        })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = nameFile.split('/teaching_notes_file/')[1]
                        link.click()
                    })
                } catch (error) {}
            },
            getFileExtension(filename)
            {
                var ext = /^.+\.([^.]+)$/.exec(filename);
                return ext == null ? "" : ext[1];
            },
            async Del(id){
                try {
                    const res = await this.$http.delete(`/teaching/note/${id}/remove/`)
                    if(res.status === 200){
                        this.LoadTeachingHistory()
                    }
                } catch (error) {}
            }
        }
    }
</script>